import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthGuardService } from '../auth/auth-guard.service';
import { AuthPassService } from '../auth/auth-pass.service';
import { AuthService } from '../auth/auth.service';
import { BoardHelpService } from '../match-tracker/tracker-board/board-help.service';
import { AuthInterceptor } from './http-interceptors/auth-interceptor';
import { HelperService } from './services/helper.service';
import { PartnerConnectService } from './services/partner-connect.service';

export function getToken() {
    return localStorage.getItem('token');
}

@NgModule({ declarations: [], imports: [CommonModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: () => {
                    return localStorage.getItem('token');
                },
            }
        }),
        FormsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        AuthService,
        AuthGuardService,
        AuthPassService,
        BoardHelpService,
        HelperService,
        PartnerConnectService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
